(() => {
  angular.module('resyApp')
    .constant('REDIRECT_CONFIG', {
      /**
       * This is a list of every route we want to define that will utilize the RedirectCtrl
       * - Each is configured with caseInsensitiveMatch: true so don't worry about that
       * - However, we must still define unique routes for variations involving hyphens
       */
      routes: [
        'animal10',
        'aussiewineweek2018',
        'pastaflyer',
        'goldencheck',
        'off-menu-week',
        'offmenuweek',
        'exclusive-tables',
        'exclusivetables',
        'off-menu-la',
        'offmenula',
        'off-menu-dc',
        'offmenudc',
        'off-menu-sf',
        'offmenusf',
        'off-menu-ny',
        'offmenuny',
        'off-menu-chi',
        'offmenuchi',
        'off-menu-atx',
        'offmenuatx',
        'offmenuatl',
        'offmenuchs',
        'offmenuhou',
        'resy-lotto',
        'resylotto',
        'the-neighborhood',
        'theneighborhood',
        'women-of-food',
        'womenoffood',
        'franks',
        'frankies',
        'birdiegs',
        'birdie-gs',
        'bollinger',
        'women-of-food-uk',
        'womenoffooduk',
        'dine-earn-amex',
        'dineearnamex',
        'mission-chinese',
        'missionchinese',
        'alison-roman',
        'alisonroman',
        'newsroom',
        'at-home',
        'athome',
        'at-home-specials',
        'athomespecials',
      ],
      /**
       * This is the map that a defined route will match against in the RedirectCtrl
       * We process the route in a few ways to generate the key:
       * - ignore leading slash ("/") -- so don't put it in the route value
       * - toLowerCase -- don't worry about case
       * - remove all hyphens
       */
      map: {
        animal10: 'https://blog.resy.com/animal-10th-anniversary-fairfax-tour-resy',
        aussiewineweek2018: 'https://blog.resy.com/aussie-wine-week-2018',
        pastaflyer: 'https://blog.resy.com/mark-ladners-supper-series-pasta-flyer',
        goldencheck: 'https://blog.resy.com/golden-check',
        offmenuweek: 'https://blog.resy.com/2019/01/off-menu-week',
        exclusivetables: 'https://blog.resy.com/2019/01/exclusive-tables',
        offmenula: 'https://blog.resy.com/2019/01/off-menu-week-la',
        offmenudc: 'https://blog.resy.com/2019/03/off-menu-week-dc',
        offmenusf: 'https://blog.resy.com/2019/05/off-menu-week-sf',
        offmenuny: 'https://blog.resy.com/2019/08/off-menu-week-ny',
        offmenuchi: 'https://blog.resy.com/2019/09/off-menu-week-chicago',
        offmenuatx: 'https://blog.resy.com/2019/09/off-menu-week-atx',
        offmenuatl: 'https://blog.resy.com/2020/02/resy-off-menu-week-atlanta/',
        offmenuchs: 'https://blog.resy.com/2020/03/resy-off-menu-week-charleston/',
        offmenuhou: ' https://blog.resy.com/2020/11/resy-off-menu-week-houston/',
        resylotto: 'https://blog.resy.com/resylotto',
        theneighborhood: 'https://blog.resy.com/2019/02/the-neighborhood-series',
        womenoffood: 'https://blog.resy.com/2019/03/resy-presents-women-of-food',
        franks: 'https://blog.resy.com/2019/05/resy-franks-backyard-chef-series-3',
        frankies: 'https://blog.resy.com/2019/05/resy-franks-backyard-chef-series-3',
        birdiegs: 'https://blog.resy.com/2019/05/the-making-of-birdie-gs',
        bollinger: 'https://blog.resy.com/2019/05/bollinger',
        womenoffooduk: 'https://blog.resy.com/2019/06/women-of-food-uk/',
        dineearnamex: 'https://blog.resy.com/earn-more-dine-out-amex-resy/',
        missionchinese: 'https://blog.resy.com/2019/08/mission-chinese-secret-special-danny-bowien/',
        alisonroman: 'https://blog.resy.com/alison-roman/',
        newsroom: 'https://blog.resy.com/newsroom/',
        athome: 'https://blog.resy.com/at-home',
        athomespecials: 'https://blog.resy.com/2020/06/at-home-specials/',
      },
    });
})();

export default () => {};
